(function($) {
  
  $(document).ready(function() {
      
  });
  
})(jQuery);

function initWpTheContent(){
  var $ = jQuery;
  $('.m-wp-the_content table').wrap("<div class='table-wrapper'></div>")
  $('.m-wp-the_content table .pix-caption').each(function(){
    var width = $(this).css('max-width');
    console.log(width);
    $(this).attr('style','max-width:'+width+' !important;width:'+width+' !important;')
  })
  //$('.m-wp-the_content table .pix-caption').attr('style','max-width:150px !important')
}